import { lazyLoad } from 'utils/loadable';

export const PaymentProcessing = lazyLoad(
  () => import('./index'),
  module => module.PaymentProcessing,
);